import abyssalSquid from "@/assets/sprites/units/abyssal-squid.svg";
import alligator from "@/assets/sprites/units/alligator.svg";
import ant from "@/assets/sprites/units/ant.svg";
import beastTamer from "@/assets/sprites/units/beast-tamer.svg";
import bee from "@/assets/sprites/units/bee.svg";
import clayGolem from "@/assets/sprites/units/clay-golem.svg";
import dragonfly from "@/assets/sprites/units/dragonfly.svg";
import fireAnt from "@/assets/sprites/units/fire-ant.svg";
import fireAlligator from "@/assets/sprites/units/fire-alligator.svg";
import goblinArcher from "@/assets/sprites/units/goblin-archer.svg";
import goblinChief from "@/assets/sprites/units/goblin-chief.svg";
import goblinShaman from "@/assets/sprites/units/goblin-shaman.svg";
import goblin from "@/assets/sprites/units/goblin.svg";
import knight from "@/assets/sprites/units/knight.svg";
import merman from "@/assets/sprites/units/merman.svg";
import octopus from "@/assets/sprites/units/octopus.svg";
import rat from "@/assets/sprites/units/rat.svg";
import shopkeeperCaged from "@/assets/sprites/units/shopkeeper-caged.svg";
import shopkeeper from "@/assets/sprites/units/shopkeeper.svg";
import skeletonBrachiosaurus from "@/assets/sprites/units/skeleton-brachiosaurus.svg";
import skeletonGiraffe from "@/assets/sprites/units/skeleton-giraffe.svg";
import skeletonHippo from "@/assets/sprites/units/skeleton-hippo.svg";
import skeletonKing from "@/assets/sprites/units/skeleton-king.svg";
import skeletonPrince from "@/assets/sprites/units/skeleton-prince.svg";
import skeletonRhino from "@/assets/sprites/units/skeleton-rhino.svg";
import skeleton from "@/assets/sprites/units/skeleton.svg";
import spider from "@/assets/sprites/units/spider.svg";
import squidKnight from "@/assets/sprites/units/squid-knight.svg";
import squidTentacle from "@/assets/sprites/units/squid-tentacle.svg";
import undertaker from "@/assets/sprites/units/undertaker.svg";
import worm from "@/assets/sprites/units/worm.svg";
import blacksmith from "@/assets/sprites/units/blacksmith.svg";
import mummy from "@/assets/sprites/units/mummy.svg";
import miner from "@/assets/sprites/units/miner.svg";
import caveBat from "@/assets/sprites/units/cave-bat.svg";
import mimic from "@/assets/sprites/units/mimic.svg";
import glowScorpion from "@/assets/sprites/units/glow-scorpion.svg";
import oreBeetle from "@/assets/sprites/units/ore-beetle.svg";
import gloomWisp from "@/assets/sprites/units/gloom-wisp.svg";
import basaltWyrm from "@/assets/sprites/units/basalt-wyrm.svg";
import abyssalOoze from "@/assets/sprites/units/abyssal-ooze.svg";
import oozeGuardian from "@/assets/sprites/units/ooze-guardian.svg";
import potionmaster from "@/assets/sprites/units/potionmaster.svg";
import forgeling from "@/assets/sprites/units/forgeling.svg";
import chainForgeling from "@/assets/sprites/units/chain-forgeling.svg";
import bellowsForgeling from "@/assets/sprites/units/bellows-forgeling.svg";
import hammerForgeling from "@/assets/sprites/units/hammer-forgeling.svg";
import rustmireEngine from "@/assets/sprites/units/rustmire-engine.svg";
import brineDynamo from "@/assets/sprites/units/brine-dynamo.svg";
import barnacleDrone from "@/assets/sprites/units/barnacle-drone.svg";
import cartographer from "@/assets/sprites/units/cartographer.svg";
import angler from "@/assets/sprites/units/angler.svg";
import direRat from "@/assets/sprites/units/dire-rat.svg";
import soldierAnt from "@/assets/sprites/units/soldier-ant.svg";
import sewerToad from "@/assets/sprites/units/sewer-toad.svg";
import oddityBrewer from "@/assets/sprites/units/oddity-brewer.svg";
import coconutBailiff from "@/assets/sprites/units/coconut-bailiff.svg";
import reefAuditor from "@/assets/sprites/units/reef-auditor.svg";
import vacationEmperor from "@/assets/sprites/units/vacation-emperor.svg";

export const unitSprites = {
  abyssalSquid, alligator, ant, beastTamer, bee, clayGolem, dragonfly, fireAlligator, fireAnt,
  goblin, goblinArcher, goblinChief, goblinShaman, knight, merman, octopus, rat,
  shopkeeper, shopkeeperCaged, skeleton, skeletonBrachiosaurus, skeletonGiraffe,
  skeletonHippo, skeletonKing, skeletonPrince, skeletonRhino, spider, squidKnight,
  squidTentacle, undertaker, worm, blacksmith, mummy, miner, caveBat, mimic,
  glowScorpion, oreBeetle, gloomWisp, basaltWyrm, abyssalOoze, oozeGuardian, potionmaster,
  forgeling, chainForgeling, bellowsForgeling, hammerForgeling,
  rustmireEngine, brineDynamo, barnacleDrone, cartographer, angler, direRat, soldierAnt, sewerToad,
  oddityBrewer,
  coconutBailiff, reefAuditor, vacationEmperor,
} as const;
